import ViewGreeting from "./ViewGreeting";

export default ViewGreeting